var hasBlanket = false;
var hasPillowCover = false;
var isBackup = false;
var blanketQty = 0;
var pillowCoverQty = 0;
var bundleLink;

function addQty(product) {
    if (product.product_type == "Beddy's" && product.quantity < 1) {
      product.quantity += 1;
    } else if (product.product_type == "Blankets" && product.selected_variant.inventory_quantity - 1 >= product.quantity) { 
      blanketQty += 1;
      product.quantity += 1;
    } else if (product.product_type == "Pillow Covers" || product.product_type == "Pillows" && product.selected_variant.inventory_quantity - 1 >= product.quantity) {
      pillowCoverQty += 1;
      product.quantity += 1;
    } else if (product.product_type != "Beddy's" && product.selected_variant.inventory_quantity - 1 >= product.quantity) {
      product.quantity += 1;
    }

  }

  function subQty(product) {
    if (product.product_type == "Blankets" && product.quantity > 0) { 
      blanketQty -= 1;
      product.quantity -= 1;
    } else if (product.product_type == "Pillow Covers" || product.product_type == "Pillows" && product.quantity > 0) {
      pillowCoverQty -= 1;
      product.quantity -= 1;
    } else if (product.quantity > 0) {
      product.quantity -= 1;
    }
  }

document.addEventListener('rebuy.ready', function(event){
    const widget = window.Rebuy.widgets.find((w) => w.id === "70503");
    if (widget.data.products != undefined && !hasBlanket && !hasPillowCover) {
      if (widget.data.metadata.custom.bundle_url) {
          bundleLink = widget.data.metadata.custom.bundle_url;
      }
  
      widget.data.products.forEach(product => {
          var totalQty = 0;
  
          product.variants.forEach(variant => {
              totalQty += variant.inventory_quantity;
          });
  
          if (product.product_type == "Blankets" && !hasBlanket && !isBackup) {
              blanketQty += product.quantity;
              hasBlanket = true;
              isBackup = true;
          } else if (product.product_type == "Blankets" && !hasBlanket && isBackup) {
              blanketQty += product.quantity;
              hasBlanket = true;
              product.backup = true;
          } else if (product.product_type == "Blankets" && hasBlanket) {
              product.selected = false;
              product.hide = true;
          } else if (product.product_type == "Pillow Covers" || product.product_type == "Pillows" && totalQty > 0) {
              pillowCoverQty += product.quantity;
              hasPillowCover = true;
          }
  
          if (totalQty < 1 && product.product_type != 'Graphics') {
              product.selected = false;
              product.quantity = 0;
              product.stock = false;
          } else {
              product.stock = true;
          }
      });
    }
});